export const ApiDeviceIds = {
  isWebView: '01',
  isMobileView: '02',
  isAndroid: '03',
  isIOs: '04',
};

let currentDeviceAgent = { dId: '01', userAgent: {} };

export const setCurrentDeviceAgent = ({ userAgent, ...props }) => {
  const { platform, isMobile } = props;
  const dId =
    (platform &&
      (platform === 'ios'
        ? ApiDeviceIds['isIOs']
        : ApiDeviceIds['isAndroid'])) ||
    (isMobile && ApiDeviceIds['isMobileView']) ||
    ApiDeviceIds['isWebView'];

  currentDeviceAgent = { dId, userAgent: `${platform || ''}${userAgent}` };
};

export const getCurrentDeviceAgent = () => currentDeviceAgent;
